import { Injectable } from "@angular/core";
import moment from "moment";
import { Cluster } from "src/app/ui/models/domains/pbm/clusters/cluster.model";
import { AbstractParser } from "../../parser";
import { parseCluster, parseClusterKey } from "./cluster-functions";

@Injectable()
export class ClusterParser extends AbstractParser<any> {
  parse(payload: any): Cluster {
    const cluster = new Cluster(
      parseClusterKey(payload.ClusterKey),
      payload.Name,
      payload.TotalProducts,
      moment(payload.CreateDate).format("DD/MM/YYYY"),
      moment(payload.LastChangeDate).format("DD/MM/YYYY"),
      payload.Data,
    );

    return cluster;
  }
}
